import { Outlet, useOutletContext } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import FoldersSettings from 'modules/documents/components/Settings/Folders'
import { SPACES } from 'modules/documents/lib/constants'

interface OutletContext {
  canManageFolders: boolean
}

const InternalFolderSettingPage = () => {
  const space = SPACES.COMPANY_INTERNAL
  const folderVariables = { space, rootFolders: true }
  const { company } = useCurrentSession()
  const { navigation } = useNavigation()
  const { canManageFolders } = useOutletContext<OutletContext>()

  return (
    <>
      <Outlet
        context={{
          parentRoute: navigation.settings.folders.internal.fullPath(),
          space,
          companyId: company.id,
        }}
      />

      <FoldersSettings
        space={space}
        folderVariables={folderVariables}
        canManage={canManageFolders}
        newFolderRoute={navigation.settings.folders.internal.new.fullPath()}
      />
    </>
  )
}

export default InternalFolderSettingPage
